import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { submenu } from './sub.menu';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { MenuItemsModel } from '@core/menu/menu.model';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';


const dataPrivilege: Record<'moduleMenu', MenuItemsModel[]> = {
    moduleMenu: submenu,
};

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Rejected,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Rejected,
        title: marker('modules.rejected.head'),
        loadComponent: () =>
            import('./features/rejected/rejected.component').then(
                (c) => c.RejectedComponent,
            ),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Suspicious,
        title: marker('modules.suspicious.head'),
        loadComponent: () =>
            import('./features/suspicious/suspicious.component').then(
                (c) => c.SuspiciousComponent,
            ),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Ids,
        title: marker('global.labels.ids'),
        loadComponent: () =>
            import('./features/ids/ids.component').then((c) => c.IdsComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.Reasons,
        title: marker('modules.settings.head'),
        loadComponent: () =>
            import('./features/settings/settings.component').then(
                (c) => c.SettingsComponent,
            ),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
